import React, { useState, useEffect, useMemo } from "react";
import toast from "react-hot-toast";
import api from "../api/Api";
import "./PrepareSalaryPage.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// const salaryData = [
//   {
//     id: 1,
//     name: "ABC (D1)",
//     salary: 15000,
//     leave: 3,
//     leaveDeduction: 1500,
//     extraAllowance: 100,
//     adv: 500,
//     loan: 300,
//     lic: 150,
//     d1: 50,
//     d2: 0,
//   },
//   {
//     id: 2,
//     name: "XYZ (D2)",
//     salary: 18000,
//     leave: 2,
//     leaveDeduction: 1200,
//     extraAllowance: 0,
//     adv: 0,
//     loan: 0,
//     lic: 0,
//     d1: 0,
//     d2: 0,
//   },
// ];

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const PrepareSalaryPage = () => {
 const navigate = useNavigate();

  const { month, year } = useParams();
  const today = new Date();

  // const [selectedMonth, setSelectedMonth] = useState(today.getMonth());
  // const [selectedYear, setSelectedYear] = useState(today.getFullYear());



const initialMonth = month ? Number(month) : new Date().getMonth();
const initialYear = year ? Number(year) : new Date().getFullYear();

const [selectedMonth, setSelectedMonth] = useState(initialMonth);
const [selectedYear, setSelectedYear] = useState(initialYear);

  const [saveAttendanceList, setSaveAttendanceList] = useState([]);
  const [extraAllowance, setExtraAllowance] = useState({});
  const [deductions, setDeductions] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [comments, setComments] = useState([]);
    const [getPaymentMode, setPaymentMode] = useState([]);
  const [salBasicList, setfetchBasicSal] = useState([]);
  const [preperSalay, setPreperSalay] = useState([]);
  // checkbox state (idx based)
  const [checkedRows, setCheckedRows] = useState({});
  const [checkAll, setCheckAll] = useState(false);
const [showAttendanceModal, setShowAttendanceModal] = useState(false);
const [attendanceData, setAttendanceData] = useState([]);
const [getDriverId, setDriverId] = useState('');
const [getDriverName, setDriverName] = useState('');
const totalDaysMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();

  /* ================= MONTH DATE RANGE ================= */
  const { firstDate, lastDate } = useMemo(() => {
    const first = new Date(selectedYear, selectedMonth, 1);
    const last = new Date(selectedYear, selectedMonth + 1, 0);

    return {
      firstDate: first.toISOString().split("T")[0],
      lastDate: last.toISOString().split("T")[0],
    };
  }, [selectedMonth, selectedYear]);

  /* ================= FETCH MONTHLY ATTENDANCE ================= */
  useEffect(() => {
    fetchSaveAttendance();
    fetchBasicSal();
    chkPreperSalay();
  }, [selectedMonth, selectedYear]);

  const fetchSaveAttendance = async () => {
    try {
      const resp = await api.get(
        `/adminmodSalary/getForSalaryProcess/${selectedMonth + 1}/${selectedYear}`,
      );

      setSaveAttendanceList(resp.data?.data || []);
    } catch (err) {
      toast.error("Failed to load saved attendance");
    }
  };

  /* ================= YEAR LIST ================= */
  const years = [
    today.getFullYear() - 2,
    today.getFullYear() - 1,
    today.getFullYear(),
  ];
  // const salaryData =
  //   saveAttendanceList?.[0]?.driver_summary || [];

  const salaryData = useMemo(() => {
    const raw = saveAttendanceList?.[0]?.driver_summary;

    if (!raw) return [];

    try {
      return typeof raw === "string" ? JSON.parse(raw) : raw;
    } catch (e) {
      console.error("Invalid driver_summary JSON", e);
      return [];
    }
  }, [saveAttendanceList]);

  const handleDeductionChange = (idx, field, value) => {
    setDeductions((prev) => ({
      ...prev,
      [idx]: {
        ...prev[idx],
        [field]: value === "" ? "" : Number(value),
      },
    }));
  };

  const getTotalDeduction = (idx) => {
    const d = deductions[idx] || {};
    return (
      (Number(d.adv) || 0) +
      (Number(d.loan) || 0) +
      (Number(d.lic) || 0) +
      (Number(d.d1) || 0) +
      (Number(d.d2) || 0)
    );
  };

  //CHECK  SALARY SUBMIT ARE NOT AREA START//
  const handlePrepareClick = async () => {
    try {
      setShowConfirm(true);
    } catch (err) {
      console.error(err);
    }
  };

  //CHECK SALARY SUBMIT ARE NOT AREA END//

  // save data area start//
  const handlePrepareSalary = async () => {
    try {
      const payload = salaryData
        .filter((_, idx) => checkedRows[idx]) // ONLY SELECTED ROWS
        .map((row, idx) => {
          const attendance = getAttendanceByDriver(row.driver_regno);
          let totalDays = 0;
          let perDay = 0;
          let salaryMonth = 0;
          let workedDays = 0;
          let leaveDays = 0;
          let leaveDeduction = 0;
          let extra = 0;
          let grossSalary = 0;
          let totalDeduction = 0;
          let netSalary = 0;
          let paid_leave = 0;
          let total_leave =0;
          let total_salary_process = 0;
          let drvBankname = 'NA';
           let drvBankBranch = 'NA';
          let drvBankifsc = 'NA';
          let drvaccno = 'NA';   
          let paid_leave_amount=0  
          let ttalPrntAndPdLvSalary=0;
          if (attendance) {
            totalDays = totalDaysMonth;
            // perDay = 500;

            salaryMonth = Number(attendance?.basic_sal) || 0; // MONTHLY SALARY
            drvBankname = attendance?.bankname || 'NA'; 
            drvBankBranch = attendance?.bankbranch || 'NA'; 
            drvBankifsc = attendance?.bankifsc || 'NA'; 
            drvaccno = attendance?.accno || 'NA';
            perDay = Math.round(salaryMonth / totalDays);
            workedDays = row.total_salary;
        
            // leaveDeduction = leaveDays * perDay;
              total_leave = Number(row.total_leave) || 0;
           paid_leave = Number(row.paid_leave) || 0;
           total_salary_process = Number(row.total_salary_process) || 0;
            leaveDays = total_leave;
            leaveDeduction = leaveDays * perDay;
            extra = Number(extraAllowance[idx] || 0);
            paid_leave_amount=perDay * paid_leave;
            ttalPrntAndPdLvSalary=total_salary_process*perDay;
            // grossSalary = salaryMonth - leaveDeduction + extra + paid_leave_amount;
             grossSalary = ttalPrntAndPdLvSalary + extra;
            totalDeduction = getTotalDeduction(idx);
            netSalary = grossSalary - totalDeduction;
          }
          return {
            driver_regno: row.driver_regno,
            driver_name: row.driver_name,
            month: selectedMonth + 1,
            year: selectedYear,

            worked_days: workedDays,
            salary_in_month: salaryMonth,
            leave_days: leaveDays,
            paid_leave:paid_leave,
            total_salary_process:total_salary_process,
            leave_deduction: leaveDeduction,
            extra_allowance: extra,

            adv: deductions[idx]?.adv || 0,
            loan: deductions[idx]?.loan || 0,
            lic: deductions[idx]?.lic || 0,
            d1: deductions[idx]?.d1 || 0,
            d2: deductions[idx]?.d2 || 0,

            total_deduction: totalDeduction,
            gross_salary: grossSalary,
            net_salary: netSalary,

            status: "PREPARED",
            bankname : drvBankname, 
            bankBranch : drvBankBranch,
            bankifsc : drvBankifsc, 
            accno : drvaccno,
            paymentModesend: getPaymentMode[idx] || "",
            comments: comments[idx] || "",
            conform_status: 0,
          };
        });

      await api.post("/adminmodSalary/salary", { records: payload });

      toast.success("Salary prepared successfully ✅");
      fetchSaveAttendance();
      fetchBasicSal();
      chkPreperSalay();
      // window.location.href = "/admin/salary/confirm-salary";
      // window.location.href = "/salary/confirm-salary";
         // redirect page start//

    navigate(`/salary/confirm-salary/${selectedMonth + 1}/${selectedYear}`);
// redirect page end//
    } catch (err) {
      console.error(err);
      toast.error("Failed to prepare salary ❌");
    }
  };

  //UPDATE PREPER DATA ADD//
  const handlePrepareSalaryUpdate = async () => {
    try {
      let totalDays = 0;
      let perDay = 0;
      let salaryMonth = 0;
      let workedDays = 0;
      let leaveDays = 0;
      let leaveDeduction = 0;
      let extra = 0;
      let grossSalary = 0;
      let totalDeduction = 0;
      let netSalary = 0;
      let paid_leave = 0;
      let total_leave =0;
      let total_salary_process = 0;
      let drvBankname = 'NA';
      let drvBankBranch = 'NA';
      let drvBankifsc = 'NA';
      let drvaccno = 'NA';
      let paid_leave_amount=0;
      let ttalPrntAndPdLvSalary=0;
      const payload = [];

      salaryData.forEach((row, idx) => {
        // ✅ sirf checked rows
        if (!checkedRows[idx]) return;

        const attendance = getAttendanceByDriver(row.driver_regno);
        const getPreperDriverData = chkPreperDriverData(row.driver_regno);
        // console.log("chkPreperDriverData for", row.driver_regno, ":", getPreperDriverData);

        // ✅ SAME CONDITION AS YOU WANT
        if (getPreperDriverData != 1) {
          const totalDays = totalDaysMonth;
          // const perDay = 500;
          const salaryMonth = Number(attendance.basic_sal) || 0;
          drvBankname = attendance?.bankname || 'NA'; 
          drvBankBranch = attendance?.bankbranch || 'NA'; 
          drvBankifsc = attendance?.bankifsc || 'NA'; 
          drvaccno = attendance?.accno || 'NA';
          perDay = Math.round(salaryMonth / totalDays);

          const workedDays = Number(row.total_salary) || 0;
           total_leave = Number(row.total_leave) || 0;
           paid_leave = Number(row.paid_leave) || 0;
           total_salary_process = Number(row.total_salary_process) || 0;
          const leaveDays = total_leave;
          // const leaveDeduction = leaveDays * perDay;
                 paid_leave_amount=perDay * paid_leave;
                 ttalPrntAndPdLvSalary=total_salary_process*perDay;
          const leaveDeduction = leaveDays * perDay;
          const extra = Number(extraAllowance[idx]) || 0;

          // const totalDeduction =
          //   (Number(deductions[idx]?.adv) || 0) +
          //   (Number(deductions[idx]?.loan) || 0) +
          //   (Number(deductions[idx]?.lic) || 0) +
          //   (Number(deductions[idx]?.d1) || 0) +
          //   (Number(deductions[idx]?.d2) || 0);
 

          // const grossSalary = salaryMonth - leaveDeduction + extra + paid_leave_amount;
          //  grossSalary = ttalPrntAndPdLvSalary + extra;
          // const netSalary = grossSalary - totalDeduction;

             grossSalary = ttalPrntAndPdLvSalary + extra;
            totalDeduction = getTotalDeduction(idx);
            netSalary = grossSalary - totalDeduction;

          payload.push({
            driver_regno: row.driver_regno,
            driver_name: row.driver_name,
            month: selectedMonth + 1,
            year: selectedYear,

            worked_days: workedDays,
            salary_in_month: salaryMonth,
            leave_days: leaveDays,
            paid_leave:paid_leave,
            total_salary_process:total_salary_process,
            leave_deduction: leaveDeduction,
            extra_allowance: extra,

            adv: deductions[idx]?.adv || 0,
            loan: deductions[idx]?.loan || 0,
            lic: deductions[idx]?.lic || 0,
            d1: deductions[idx]?.d1 || 0,
            d2: deductions[idx]?.d2 || 0,

            total_deduction: totalDeduction,
            gross_salary: grossSalary,
            net_salary: netSalary,

            status: "PREPARED",
            bankname : drvBankname, 
            bankBranch : drvBankBranch,
            bankifsc : drvBankifsc, 
            accno : drvaccno,
            paymentModesend: getPaymentMode[idx] || "",
            comments: comments[idx] || "",
            conform_status: 0,
          });
        }
      });

      if (payload.length === 0) {
        toast.error("No valid salary records to update");
        return;
      }

      await api.post("/adminmodSalary/salaryUpdate", { records: payload });

      toast.success("Salary updated successfully ✅");
      fetchSaveAttendance();
      fetchBasicSal();
      chkPreperSalay();
      // window.location.href = "/admin/salary/confirm-salary";
      // window.location.href = "/salary/confirm-salary";
      // redirect page start//
         
    navigate(`/salary/confirm-salary/${selectedMonth+1}/${selectedYear}`);
// redirect page end//
    } catch (err) {
      console.error(err);
      toast.error("Failed to update salary ❌");
    }
  };

  //UPDATE PREPER DATA END//

  // FIND BASICSALARY
  const getAttendanceByDriver = (driverRegNo) => {
    if (!driverRegNo || !Array.isArray(salBasicList)) return null;
    return salBasicList.find((att) => {
      return att.dvr_id?.trim() === driverRegNo?.trim();
    });
  };

  const fetchBasicSal = async () => {
    try {
      const resp = await api.get("/adminmodSalary/getSalBasicData");
      // console.log(resp);
      setfetchBasicSal(resp.data?.data || []);
    } catch {
      toast.error("Failed to load Basic Salary");
    }
  };
  // save data area end//

  //CHECK ALL AREA START//
  const handleRowCheck = (idx) => {
    setCheckedRows((prev) => {
      const updated = {
        ...prev,
        [idx]: !prev[idx],
      };

      // agar koi ek bhi unchecked hai → uncheck ALL
      const allChecked =
        salaryData.length > 0 && salaryData.every((_, i) => updated[i]);

      setCheckAll(allChecked);

      return updated;
    });
  };

  const handleCheckAll = () => {
    const newValue = !checkAll;
    setCheckAll(newValue);

    const updated = {};
    salaryData.forEach((_, idx) => {
      updated[idx] = newValue;
    });

    setCheckedRows(updated);
  };

  //CHECK ALL AREA END//

  //PREPER SALARY DATA CHECK START//
  const chkPreperSalay = async () => {
    try {
      const resp = await api.get(
        `/adminmodSalary/chkPreperSalay/${selectedMonth + 1}/${selectedYear}`,
      );
      // console.log("chkPreperSalay response:", resp.data);
      setPreperSalay(resp.data?.data || []);
    } catch {
      toast.error("Failed to load Basic Salary");
    }
  };
  // const chkPreperDriverData = (driverRegNo) => {
  //   if (!driverRegNo || !Array.isArray(preperSalay)) return 2;

  //   const found = preperSalay.some((item) =>
  //     item?.salary_data?.drivers?.some(
  //       (d) => d.driver_regno?.trim() === driverRegNo?.trim(),
  //     ),
  //   );

  //   return found ? 1 : 2;
  // };
  const chkPreperDriverData = (driverRegNo) => {
  if (!driverRegNo || !Array.isArray(preperSalay)) return 2;

  const found = preperSalay.some((item) => {
    if (!item?.salary_data) return false;

    const parsedData =
      typeof item.salary_data === "string"
        ? JSON.parse(item.salary_data)
        : item.salary_data;

    return parsedData?.drivers?.some(
      (d) => d.driver_regno?.trim() === driverRegNo?.trim()
    );
  });

  return found ? 1 : 2;
};


  const totalChecked =
    preperSalay.length ||
    0;
  let totalSl = salaryData.length || 0;
  //PREPER SALARY DATA CHECK END//


  //FOR MODEL BOX  API CODE STRAT//
  const openAttendanceModal = async (driverId,driverName) => {
   setDriverId(driverId);
  setDriverName(driverName);
    const getMonth=selectedMonth + 1;
     const getYear=selectedYear;
     // First Date
const firstDateObj = new Date(getYear, getMonth - 1, 1);
const firstDate = `${firstDateObj.getFullYear()}-${String(firstDateObj.getMonth() + 1).padStart(2, "0")}-${String(firstDateObj.getDate()).padStart(2, "0")}`;

// Last Date
const lastDateObj = new Date(getYear, getMonth, 0);
const lastDate = `${lastDateObj.getFullYear()}-${String(lastDateObj.getMonth() + 1).padStart(2, "0")}-${String(lastDateObj.getDate()).padStart(2, "0")}`;


  try {
    const resp = await api.get(
      `/adminmodSalary/getDriverAttendance/${firstDate}/${lastDate}`
    );

    setAttendanceData(resp.data?.data || []);
    setShowAttendanceModal(true);
  } catch (err) {
    toast.error("Attendance load failed");
  }
};
  //FOR MODEL BOX APLI CODE END//
// FOR MODEL BOX CODE START//  
// TOTAL DAYS IN SELECTED MONTH
const daysInMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();

// FIRST DAY OF MONTH
const firstDay = new Date(selectedYear, selectedMonth, 1).getDay();

// ATTENDANCE LOOKUP MAP
const attendanceMap = {};

// ✅ Step 1: Sab dates ko "A" se fill karo
for (let i = 1; i <= daysInMonth; i++) {
  attendanceMap[i] = "A";
}

// ✅ Step 2: API data loop
attendanceData.forEach((item) => {

  if (!item.checkin_datetime) return;

  const date = parseInt(item.checkin_datetime.split("-")[2], 10);
  if (!date || date > daysInMonth) return;

  // ✅ safe JSON parse
  let jsonData = {};
  try {
    jsonData =
      typeof item.attendance_json === "string"
        ? JSON.parse(item.attendance_json)
        : item.attendance_json || {};
  } catch (e) {
    console.log("❌ Invalid JSON:", item.attendance_json);
    return;
  }

  // ✅ driverId safe match
  const driverStatus =
    jsonData[getDriverId] ||
    jsonData[getDriverId?.toUpperCase()] ||
    jsonData[getDriverId?.toLowerCase()];

  if (driverStatus) {

    // ✅ normalize
    let status = driverStatus.toString().trim().toLowerCase();

    // spaces → underscore
    status = status.replace(/\s+/g, "_");

    // custom fixes
    if (status === "halfday") status = "half_day";

    // ✅ mapping
    if (status === "present") {
      attendanceMap[date] = "P";
    } 
    else if (status === "absent") {
      attendanceMap[date] = "A";
    }
    else if (status === "half_day") {
      attendanceMap[date] = "HD";
    }
    else if (status === "leave") {
      attendanceMap[date] = "L";
    }
    else if (status === "pl") {
      attendanceMap[date] = "PL";
    }
    else {
      attendanceMap[date] = "A";
    }

  } else {
    attendanceMap[date] = "A";
  }

});

console.log("✅ Final Attendance Map:", attendanceMap);

// SUMMARY COUNT
const presentCount = Object.values(attendanceMap).filter(
  s => s === "P"
).length;
const absentCount = Object.values(attendanceMap).filter(
  s => s === "A"
).length;

const halfDayCount = Object.values(attendanceMap).filter(
  s => s === "HD"
).length;

const leaveCount = Object.values(attendanceMap).filter(
  s => s === "L"
).length;

const paidleaveCount = Object.values(attendanceMap).filter(
  s => s === "PL"
).length;

const totalPresentCount=presentCount+(halfDayCount/2);
const totalAbsentCount=absentCount+(halfDayCount/2);
const totalSalaryProcess =totalDaysMonth-totalAbsentCount;
// console.log(attendanceData);
// FOR MODEL BOX CODE END//

useEffect(() => {
  if (!salaryData.length || !salBasicList.length) return;

  const defaultModes = salaryData.map((row) => {
    const attendance = getAttendanceByDriver(row.driver_regno);
    const drvBankname = attendance?.bankname || "NA";

    return drvBankname !== "NA" ? "bank_payment" : "cash";
  });

  setPaymentMode(defaultModes);
}, [salaryData, salBasicList]);

  return (
    <div>
      {/* PAGE TITLE */}
      <div
        className="pageTitlesalary"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div>
          <h2 className="title">
            Prepare Salary – {months[selectedMonth]} {selectedYear}
          </h2>
        </div>
        <div className="controls" style={{ marginBottom: "1px" }}>
          <label>Month:</label>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(Number(e.target.value))}
          >
            {months.map((m, i) => (
              <option key={i} value={i}>
                {m}
              </option>
            ))}
          </select>
          <label>Year:</label>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
          >
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
          {/* submit area start */}
           {salaryData.length !== 0 &&
            (totalSl === totalChecked ? (
              <p style={{ color: "red", textAlign: "center" }}>
                Salary Data already Prepare for – {months[selectedMonth]}{" "}
                {selectedYear}
              </p>
            ) : (
              <button
                type="button"
                className="btn btn-success"
                disabled={!Object.values(checkedRows).some(Boolean)}
                onClick={handlePrepareClick}
              >
                PREPARE SALARY
              </button>
            ))}
          {/* submit area end */}
        </div>
      </div>

      <div className="driverAttendance-wrapper">
            <table className="salary-table" style={{ width: "100%",marginBottom:"10px",display:"none" }}>
<thead>
<tr>
<th className="sticky-col" style={{backgroundColor:"red", color:"#fff"}}>Note</th>
<th className="sticky-col"><span>Total Calender Days in {months[selectedMonth]} {selectedYear} -  {totalDaysMonth}
</span> </th>
<th className="sticky-col"><span>Total Salary Days in {months[selectedMonth]} {selectedYear} : {totalDaysMonth}
</span></th>
</tr>
</thead>
</table>

        
        {/* Month & Year Filters */}
        {/* <pre>{JSON.stringify(preperSalay?.[0]?.salary_data?.drivers?.map(d => d.driver_regno), null, 2)}</pre> */}

        {/* DEBUG */}
        {/* <pre>{JSON.stringify(saveAttendanceList, null, 2)}</pre> */}

        {/* Salary Table */}
        <div className="abstractAttendance-scroll-new">
          <table className="salary-table" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th className="sticky-col " rowSpan="2" id="prepareSalary">
                  All
                  <input
                    type="checkbox"
                    checked={checkAll}
                    onChange={handleCheckAll}
                  />
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Sl No.
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Driver Name
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Driver ID
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Salary Per Month
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Present (Days)
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Leave (Days)
                </th>
                 <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Paid Leaves (Days)
                </th>
                 <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Salary Days
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Leave Deduction
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Extra Allowance
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Gross Salary
                </th>
                <th className="sticky-col" colSpan="5" id="prepareSalary" style={{display:"none"}}>
                  Other Deductions
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Total Deduction
                </th>
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Net Salary
                </th>
                  <th className="sticky-col" rowSpan="2" id="prepareSalary" style={{width:"50%"}}>
                  Bank Account Details
                </th>

                    <th className="sticky-col" rowSpan="2" id="prepareSalary" style={{width:"50%"}}>
                  Payment Mode
                </th>
                
                <th className="sticky-col" rowSpan="2" id="prepareSalary">
                  Comments
                </th>
              </tr>
              <tr>
                <th className="sticky-col" id="prepareSalary" style={{display:"none"}}>Adv</th>
                <th className="sticky-col" id="prepareSalary" style={{display:"none"}}>Loan</th>
                <th className="sticky-col" id="prepareSalary" style={{display:"none"}}>LIC</th>
                <th className="sticky-col" id="prepareSalary" style={{display:"none"}}>D1</th>
                <th className="sticky-col" id="prepareSalary" style={{display:"none"}}>D2</th>
              </tr>
            </thead>

            <tbody>
              {salaryData.length === 0 && (
                <tr>
                  <td
                    colSpan="18"
                    style={{ textAlign: "center", color: "red" }}
                  >
                    Monthly Attendance Data Not Confirm
                  </td>
                </tr>
              )}

              {salaryData.map((row, idx) => {
                let totalday = 0;
                let perDaySalary = 0;
                let salaryMonth = 0;
                let totalSday = 0;
                let NoofLeave = 0;
                let leaveDeduction = 0;
                let extra = 0;
                let grossSalary = 0;
                let totalDeduction = 0;
                let netSalary = 0;
                 let paid_leave = 0;
                 let total_leave =0;
                  let total_salary_process = 0;
                  let drvBankname = 'NA';
                   let drvBankBranch = 'NA';
                  let drvBankifsc = 'NA';
                  let drvaccno = 'NA';
let paid_leave_amount=0;
let ttalPrntAndPdLvSalary=0;
                const attendance = getAttendanceByDriver(row.driver_regno);
                const getPreperDriverData = chkPreperDriverData(
                  row.driver_regno,
                );

                if (attendance) {
                  totalday = totalDaysMonth; // TOTAL DAY
                  // console.log("total day = "+totalday)
                  // perDaySalary = 500;            // PER DAY AMOUNT
                  salaryMonth = Number(attendance?.basic_sal) || 0; // MONTHLY SALARY
                  drvBankname = attendance?.bankname || 'NA'; 
                   drvBankBranch = attendance?.bankbranch || 'NA'; 
                  drvBankifsc = attendance?.bankifsc || 'NA'; 
                  drvaccno = attendance?.accno || 'NA';
                  perDaySalary = Math.round(salaryMonth / totalday);
                  // console.log("perday salary = "+ perDaySalary)
                  totalSday = Number(row.total_salary) || 0; // WORKING DAYS
                  paid_leave = Number(row.paid_leave) || 0;
                  total_salary_process = Number(row.total_salary_process) || 0;
                  // console.log("total_salary_process == "+total_salary_process);
 ttalPrntAndPdLvSalary=total_salary_process*perDaySalary;
                  total_leave = Number(row.total_leave) || 0;
                  NoofLeave = total_leave;
                  // console.log('NoofLeave = '+NoofLeave);
                  // leaveDeduction = NoofLeave * perDaySalary;
                  leaveDeduction = NoofLeave * perDaySalary;
                  paid_leave_amount=perDaySalary * paid_leave;
// console.log("leaveDeduction == "+leaveDeduction);
                  extra = Number(extraAllowance[idx]) || 0;
                  // grossSalary = salaryMonth - leaveDeduction + extra +paid_leave_amount;
 grossSalary = ttalPrntAndPdLvSalary + extra;

                  totalDeduction = Number(getTotalDeduction(idx)) || 0;
                  netSalary = grossSalary - totalDeduction;
                }

                // const gross =
                //   row.salary - row.leaveDeduction + row.extraAllowance;

                // const totalDeduction =
                //   row.adv + row.loan + row.lic + row.d1 + row.d2;

                // const netSalary = gross - totalDeduction;
                // RULE FOR DRIVER START//

                // RULE FOR DRIVER END//

                return (
                  <tr key={row.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          getPreperDriverData === 1 || !!checkedRows[idx]
                        }
                        disabled={getPreperDriverData === 1}
                        onChange={() => handleRowCheck(idx)}
                      />
                    </td>

                    <td>{idx + 1}</td>
                    <td>{row.driver_name}</td>
                    <td>{row.driver_regno}</td>
                    <td>{salaryMonth}</td>
                    <td>
                      <a
                        href="/driverAttendance/monthly"
                        target="_blank"
                        style={{ color: "#000" }}
                      >
                        {totalSday}
                      </a>
                      <br/>
                    <button
  className="btn btn-default btn-sm"
  onClick={() => openAttendanceModal(row.driver_regno,row.driver_name)}
>
  <i className="fa fa-info-circle" aria-hidden="true"></i>
</button>
                    </td>
                    <td>{NoofLeave}</td>
                    <td>{paid_leave}</td>
                    <td>{total_salary_process}</td>
                    <td>{leaveDeduction}</td>
                    <td>
                      <input
                        type="text"
                        className="inputBodySizep"
                        value={extra}
                        onChange={(e) =>
                          setExtraAllowance({
                            ...extraAllowance,
                            [idx]: e.target.value,
                          })
                        }
                        disabled={getPreperDriverData === 1}
                      />
                    </td>
                    <td>{grossSalary}</td>
                    <td style={{display:"none"}}>
                      <input
                        type="number"
                        className="inputBodySizep"
                        value={deductions[idx]?.adv ?? ""}
                        onChange={(e) =>
                          handleDeductionChange(idx, "adv", e.target.value)
                        }
                        disabled={getPreperDriverData === 1}
                      />
                    </td>

                    <td style={{display:"none"}}>
                      <input
                        type="number"
                        className="inputBodySizep"
                        value={deductions[idx]?.loan ?? ""}
                        onChange={(e) =>
                          handleDeductionChange(idx, "loan", e.target.value)
                        }
                        disabled={getPreperDriverData === 1}
                      />
                    </td>

                    <td style={{display:"none"}}>
                      <input
                        type="number"
                        className="inputBodySizep"
                        value={deductions[idx]?.lic ?? ""}
                        onChange={(e) =>
                          handleDeductionChange(idx, "lic", e.target.value)
                        }
                        disabled={getPreperDriverData === 1}
                      />
                    </td>

                    <td style={{display:"none"}}>
                      <input
                        type="number"
                        className="inputBodySizep"
                        value={deductions[idx]?.d1 ?? ""}
                        onChange={(e) =>
                          handleDeductionChange(idx, "d1", e.target.value)
                        }
                        disabled={getPreperDriverData === 1}
                      />
                    </td>

                    <td style={{display:"none"}}>
                      <input
                        type="number"
                        className="inputBodySizep"
                        value={deductions[idx]?.d2 ?? ""}
                        onChange={(e) =>
                          handleDeductionChange(idx, "d2", e.target.value)
                        }
                        disabled={getPreperDriverData === 1}
                      />
                    </td>

                    <td>
                      {/* {getTotalDeduction(idx)} */}
                      <input
                        type="number"
                        className="inputBodySizep"
                        value={deductions[idx]?.d2 ?? ""}
                        onChange={(e) =>
                          handleDeductionChange(idx, "d2", e.target.value)
                        }
                        disabled={getPreperDriverData === 1}
                      />
                    </td>

                    <td className="net-salary">{netSalary}</td>
                     <td>
      <span style={{fontWeight:"600"}}>Bank :</span><span> {drvBankname}</span><br/>
      <span style={{fontWeight:"600"}}>Branch :</span><span> {drvBankBranch}</span><br/>
      <span style={{fontWeight:"600"}}>IFSC Code :</span><span> {drvBankifsc}</span><br/>
      <span style={{fontWeight:"600"}}>AC No. :</span><span> {drvaccno}</span>
      
                     
                    </td>
                    <td>
                      <select
                      value={getPaymentMode[idx] || ""}
                        onChange={(e) => {
                          const updatedPaymentMode = [...getPaymentMode];
                          updatedPaymentMode[idx] = e.target.value;
                          setPaymentMode(updatedPaymentMode);
                        }}
                      className="from-control">
                        {/* <option hidden>--Select --</option> */}
                        
                         {drvBankname !='NA' && (
      <option value="bank_payment">Bank Payment</option>
    )}
                        <option value="cash">Cash</option>
                      </select>
                      
                    </td>
                    <td>
                      <input
                        type="text"
                        value={comments[idx] || ""}
                        onChange={(e) => {
                          const updated = [...comments];
                          updated[idx] = e.target.value;
                          setComments(updated);
                        }}
                        disabled={getPreperDriverData === 1}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="controls">
          {salaryData.length !== 0 &&
            (totalSl === totalChecked ? (
              <p style={{ color: "red", textAlign: "center" }}>
                Salary Data already Prepare for – {months[selectedMonth]}{" "}
                {selectedYear}
              </p>
            ) : (
              
              <button
           style={{ marginTop: "10px" }}
                type="button"
                className="btn btn-success"
                disabled={!Object.values(checkedRows).some(Boolean)}
                onClick={handlePrepareClick}
              >
                PREPARE SALARY
              </button>
            ))}

          {showConfirm && (
            <div className="confirm-overlay">
              <div className="confirm-box">
                <h5 style={{ color: "green" }}>Confirm Salary Preparation</h5>

                <p>Are you sure you want to prepare salary?</p>

                <div className="confirm-actions">
                  <button
                    className="btn-cancel"
                    onClick={() => setShowConfirm(false)}
                  >
                    Cancel
                  </button>

                  {totalChecked !== 0 ? (
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        setShowConfirm(false);
                        handlePrepareSalaryUpdate();
                      }}
                    >
                      Yes, Prepare 
                    </button>
                  ) : (
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        setShowConfirm(false);
                        handlePrepareSalary();
                      }}
                    >
                      Yes, Prepare 
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* MODEL BOX CODE AREA START */}
{showAttendanceModal && (
  
       
  <div className="attendanceModalOverlay">
 {/* <pre>{JSON.stringify(attendanceData, null, 2)}</pre> */}
    <div className="attendanceModalBox">

      <div className="attendanceHeader" >
        <h4>{months[selectedMonth]}-{selectedYear}</h4>

        <button
          className="closeBtn"
          onClick={() => setShowAttendanceModal(false)}
        >
          <i class="fa fa-window-close" aria-hidden="true"></i>
        </button>
   
      </div>

      <div className="attendanceHeader1">
     
         <h4 style={{textAlign:"center",fontSize:"19px"}}>
          <span>{getDriverName}</span> <span style={{color:"green"}}>({getDriverId})</span>
         
        </h4>
      </div>

      {/* WEEK HEADER */}
      <div className="weekHeader">
        {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map((d,i)=>(
          <div key={i}>{d}</div>
        ))}
      </div>

      {/* CALENDAR GRID */}
      <div className="calendarGrid">

        {/* EMPTY SPACE BEFORE FIRST DAY */}
        {Array.from({ length: firstDay }).map((_, i) => (
          <div key={"empty"+i}></div>
        ))}

        {/* DAYS */}
        {Array.from({ length: daysInMonth }, (_, i) => {

          const day = i + 1;
          const status = attendanceMap[day];

          return (
            <div key={day} className="calendarDay">

              <div className="date">{day}</div>

              {status && (
                  <div className={`statusBox status${status}`}>
                  {status}
                </div>
              )}

            </div>
          );
        })}

      </div>

      {/* SUMMARY */}
      <div className="attendanceSummary">

        <div className="presentBox" style={{display:"none"}}>
          Present: {presentCount}
        </div>

        <div className="absentBox" style={{display:"none"}}>
          Absent: {absentCount}
        </div>


      </div>

         <div className="attendanceSummary">

        

          <div className="halfDayBox" style={{fontSize:"10px"}}>
         HD : Half Day = {halfDayCount}
        </div>
         <div className="absentBox" style={{fontSize:"10px"}}>
         A : Absent = {absentCount}
        </div>
<div className="leaveBox" style={{fontSize:"10px"}}>
          Leave = {totalAbsentCount}
        </div>

        <div className="paidLeaveBox" style={{fontSize:"10px"}}>
         PL : Paid Leave = {paidleaveCount}
        </div>

      </div>

      <div className="attendanceSummary">
<div className="presentBox">
        Total Present (Days): {totalPresentCount}
        </div>

        <div className="salaryBox">
        Total Salary (Days): {totalSalaryProcess}
        </div>
        
      </div>

           

    </div>
  </div>
)}
          {/* MODEL BOX CODE ARRA END */}
        </div>
      </div>
    </div>
  );
};

export default PrepareSalaryPage;
